import { Component } from "react"
import PropTypes from "prop-types"

import PopulatorValue from "./populator_value"
import { StatusRow } from "./table_components"
import { findTypeByID } from "partners/components/shared/stencilable_field_types"

const TYPE_NAME = {
  title: "Title of a blog post, email subject, or other short text",
  collection_title: "Title of a document",
  html: "HTML",
  message: "Short text (140 characters or fewer)",
  body: "Long text (greater than 140 characters)",
  mobile: "Notification (e.g., for Mobile)",
  filename: "File name",
  folder: "Path to a folder",
  tags: "Tags",
  link_url: "Link",
  photo_url: "Photo",
  file_url: "File",
  audio_url: "Audio",
  text_datetime: "ISO 8601 Date and time",
  text_raw: "Text (other)",
  dropdown_static: "Dropdown list (populated with specified items)",
  dropdown_dynamic: "Dropdown list (populated dynamically)",
}

class ActionField extends Component {
  renderAttributes() {
    const { actionField, feedbackItems = {}, diffStyle, pathObjs } = this.props
    let attributes = [
      {
        key: `action-field-item-name-${actionField.id}`,
        name: "Label",
        value: actionField.name,
        required: true,
        fieldName: "name",
      },
      {
        key: `action-field-item-helper-text-${actionField.id}`,
        name: "Optional helper text",
        value: actionField.helper_text,
        fieldName: "helper_text",
      },
      {
        key: `action-field-item-slug-${actionField.id}`,
        name: "Key name",
        value: actionField.slug,
        required: true,
        fieldName: "slug",
      },
      {
        key: `action-field-shareable-${actionField.id}`,
        name: "Private?",
        value: actionField.shareable,
        fieldName: "shareable",
        transform: value => (value ? "No" : "Yes"),
      },
      {
        key: `action-field-item-required-${actionField.id}`,
        name: "Required?",
        value: actionField.required,
        transform: value => (value ? "Yes" : "No"),
        fieldName: "required",
      },
      {
        key: `action-field-item-field-type-${actionField.id}`,
        name: "Field Type",
        value: actionField.action_field_type,
        transform: value =>
          TYPE_NAME[findTypeByID(value)] || "Unknown Field Type",
        fieldName: "action_field_type",
      },
    ]

    if (actionField.action_field_type === 14) {
      const diffs = this.props.changes.filter(
        diff => diff.path[4] === "populator_values"
      )
      const originalChannel = this.props.originalChannel
      attributes = attributes.concat({
        key: "action-field-item-populator-values",
        name: "Dropdown Options",
        value: actionField.populator_values,
        transform: value => (
          <PopulatorValue
            diffStyle={diffStyle}
            originalChannel={originalChannel}
            values={value}
            changes={diffs}
            parent="actions"
            collection="action_fields"
          />
        ),
        fieldName: "populator_values",
      })
    }

    const submenuIcons = JSON.parse(window.sessionStorage.submenuIcons)
    return attributes.map(item => {
      item.feedback = feedbackItems[item.fieldName]
      item.pathObjs = [...pathObjs, actionField.id, item.fieldName]
      item.diff = this.props.changes.find(
        diff =>
          diff.data &&
          diff.data.property === item.fieldName &&
          diff.path.length === 4
      )
      if (item.feedback && !submenuIcons.actionsFeedback) {
        this.props.setSessionFeedback("actions", submenuIcons)
      }
      return this.props.tableRow(item)
    })
  }

  render() {
    return (
      <table className="subtable">
        <tbody>
          {this.props.diffStyle !== "none" && (
            <StatusRow status={this.props.status} />
          )}
          {this.renderAttributes()}
        </tbody>
      </table>
    )
  }
}

ActionField.propTypes = {
  diffStyle: PropTypes.string.isRequired,
  originalChannel: PropTypes.object,
  status: PropTypes.oneOf(["new", "deleted", "updated", "stale"]).isRequired,
  pathObjs: PropTypes.array.isRequired,
  actionField: PropTypes.object.isRequired,
  changes: PropTypes.array.isRequired,
  feedbackItems: PropTypes.object,
  tableRow: PropTypes.func.isRequired, // Should be imported
  setSessionFeedback: PropTypes.func.isRequired,
}

export default ActionField
